import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private requestCount = 0;
  private showTimeout: ReturnType<typeof setTimeout> | null = null;

  private loadingSubject = new BehaviorSubject(false);
  readonly loading$ = this.loadingSubject.asObservable();

  show(): void {
    this.requestCount++;

    if (this.requestCount === 1) {
      this.showTimeout = setTimeout(() => {
        if (this.requestCount > 0) {
          this.loadingSubject.next(true);
        }
      }, environment.loadingTimeout);
    }
  }

  hide(): void {
    if (this.requestCount > 0) {
      this.requestCount--;
    }

    if (this.requestCount === 0) {
      if (this.showTimeout) {
        clearTimeout(this.showTimeout);
        this.showTimeout = null;
      }

      this.loadingSubject.next(false);
    }
  }
}